<sh-datepicker
  #datepicker
  range
  future-date-disable
  [value]="currentDateRange()"
  (value-changed)="onDateRangeChange(datepicker.value)"
  label="{{ 'spareParts.dateRange' | translate }}"
  [separator]="dateFormat()?.shuiSeparator"
  [format]="dateFormat()?.shuiFormat"
  [min]="minPropertyToDatepicker()"
></sh-datepicker>
